import { gql } from '@apollo/client';

export const GET_SEARCH_PRICE = gql`
  query searchResultPrice(
    $bookingType: String!
    $endDate: String!
    $petTypes: [Int!]
    $scheduledDates: [String!]
    $serviceTypeId: Int!
    $sitterId: Int!
    $startDate: String!
    $startDateOfWeek: String!
    $weekDays: [Boolean!]
  ) {
    searchResultPrice(
      bookingType: $bookingType
      endDate: $endDate
      petTypes: $petTypes
      scheduledDates: $scheduledDates
      serviceTypeId: $serviceTypeId
      sitterId: $sitterId
      startDate: $startDate
      startDateOfWeek: $startDateOfWeek
      weekDays: $weekDays
    ) {
      ownerFee
      servicesTotal
      preview {
        averagePrice {
          string
          value
        }
        basePrice {
          string
          value
        }
        totalPrice {
          string
          value
        }
      }
      mainService {
        bulkDiscount {
          description
          percent
        }
        rate
        serviceDescriptions {
          additionalPetRate
          additionalPetCost
          puppySurcharge
          puppySurchargeCost
          singlePetRate
        }
        serviceTypeId
        subTotal
        timeUnits
        total
      }
    }
  }
`;
